import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import usermanagementConstant from "./../Constants/UsermanagementConstants";

class UserManagementActions {
  getUsers(adminid, page, pageSize, offset, option = "") {
    //, int page, int pageSize, string option

    httpRequest(
      config.webServiceURL +
        "/usermanagement/users?adminId=" +
        adminid +
        "&page=" +
        page +
        "&pageSize=" +
        pageSize +
        "&offset=" +
        offset +
        "&option=" +
        option,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USERS_SUCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USERS_FAILURE,
          });
        }
      },
    );
  }

  getUserDetails(userid) {
    httpRequest(
      config.webServiceURL + "/usermanagement/userdetail?userid =" + userid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USER_DETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USER_DETAILS_FAILURE,
          });
        }
      },
    );
  }

  addOrUpdateUser(user) {
    httpRequest(
      config.webServiceURL + "/UserManagement/AddOrUpdateUser",
      "PUT",
      JSON.stringify({
        ID: user.ID,
        Vorname: user.Vorname,
        Nachname: user.Nachname,
        Username: user.Username,
        Email: user.Email,
        PersonalNr: user.PersonalNr,
        WerkID: user.WerkID,
        IsExtern: user.IsExtern === "true" ? true : false,
        Aktiv: user.Aktiv,
        Passwort: "",
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  addOrUpdateOrganisation(organisation) {
    httpRequest(
      config.webServiceURL + "/Organisation/AddOrUpdateOrganisation",
      "POST",
      JSON.stringify({
        ID: organisation.ID,
        Name: organisation.Name,
        IsBlocked: organisation.IsBlocked,
        BlockingReason: organisation.BlockingReason,
        Language: organisation.Language,
        DateFormat: organisation.DateFormat,
        TimeZone: organisation.TimeZone,
        SubDomain: organisation.SubDomain,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_ORGANISATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_ORGANISATION_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getOrganisations() {
    httpRequest(
      config.webServiceURL + "/Organisation/GetOrganisations",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORGANISATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORGANISATION_FAILURE,
          });
        }
      },
    );
  }

  blockOrganisation(blockData) {
    httpRequest(
      config.webServiceURL +
        "/Organisation/BlockOrganisation/" +
        blockData.organisationId +
        "/" +
        blockData.reason,
      "PATCH",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.BLOCK_ORGANISATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.BLOCK_ORGANISATION_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  UnblockOrganisation(orgid) {
    httpRequest(
      config.webServiceURL + "/Organisation/UnblockOrganisation/" + orgid,
      "PATCH",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.UNBLOCK_ORGANISATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.UNBLOCK_ORGANISATION_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  blockUser(blockuser) {
    httpRequest(
      config.webServiceURL +
        "/UserManagement/BlockUser/" +
        blockuser.userId +
        "/" +
        blockuser.reason,
      "PATCH",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.BLOCK_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.BLOCK_USER_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  UnblockUser(userid) {
    httpRequest(
      config.webServiceURL + "/UserManagement/UnblockUser/" + userid,
      "PATCH",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.UNBLOCK_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.UNBLOCK_USER_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  getPlantsByUserId() {
    httpRequest(
      config.webServiceURL + "/Werk/GetMyWerks/",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_FAILURE,
          });
        }
      },
    );
  }

  getPlants(orgId) {
    httpRequest(
      config.webServiceURL + "/Werk/GetWerks/" + orgId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_FAILURE,
          });
        }
      },
    );
  }

  addOrganisationAdmin(data) {
    httpRequest(
      config.webServiceURL + "/Organisation/AddOrganisationAdmin",
      "POST",
      JSON.stringify({
        ...data,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADD_ORGANISATION_ADMIN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADD_ORGANISATION_ADMIN_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getFilteredUsers(filterData) {
    httpRequest(
      config.webServiceURL + "/UserManagement/GetUsers",
      "POST",
      JSON.stringify({
        WerkID: filterData.current.WerkID,
        Vorname: filterData.current.Vorname.trim(),
        Nachname: filterData.current.Nachname.trim(),
        Username: filterData.current.Username,
        PersonalNr: filterData.current.PersonalNr,
        Aktiv: filterData.current.Aktiv,
        IsExtern: filterData.current.IsExtern,
        Email: filterData.current.Email,
      }),
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_FILTERED_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_FILTERED_USER_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  getRoles() {
    httpRequest(config.webServiceURL + "/Role/GetRoles", "GET", null, (res) => {
      if (res !== "Error") {
        dispatcher.dispatch({
          type: usermanagementConstant.GET_ROLE_SUCCESS,
          result: res,
        });
      } else {
        dispatcher.dispatch({
          type: usermanagementConstant.GET_ROLE_FAILURE,
        });
      }
    });
  }

  addOrUpdateRoleToUser(roleData) {
    httpRequest(
      config.webServiceURL + "/Role/BenutzerRolleAddUpdate",
      "POST",
      JSON.stringify({
        ID: roleData.ID,
        IsDesktop: roleData.IsDesktop,
        UserId: roleData.UserId,
        RoleId: parseInt(roleData.RoleId),
        AnlagegruppeIDs: roleData.AnlagegruppeID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_ROLE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_ROLE_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  addOrUpdateCostCentreByPlantId(costCenterData) {
    httpRequest(
      config.webServiceURL + "/Kost/AddOrUpdateKostenstelle/",
      "POST",
      JSON.stringify({
        ID: costCenterData.ID,
        Kost: costCenterData.Kost,
        WerkID: costCenterData.WerkID,
        KostGroupID: costCenterData.KostGroupID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_COST_CENTRE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_COST_CENTRE_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getUserRoles(userid) {
    httpRequest(
      config.webServiceURL + "/Role/GetUserRoles/" + userid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USER_ROLE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_USER_ROLE_FAILURE,
          });
        }
      },
    );
  }

  getCostCentreByWerkId(werkId) {
    httpRequest(
      config.webServiceURL + "/Kost/GetKostenstelles/" + werkId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_COST_CENTER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_COST_CENTER_FAILURE,
            res,
          });
        }
      },
    );
  }

  addOrUpdateCostCentreToUser(costCentreData) {
    httpRequest(
      config.webServiceURL + "/Role/BenutzerRolleKostenstelleAddUpdate",
      "POST",
      JSON.stringify({
        UserRoleId: costCentreData.UserRoleId,
        KostenstelleID: costCentreData.KostenstelleID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_COST_CENTRE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADDORUPDATE_COST_CENTRE_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getCostCentreForUser(userId) {
    httpRequest(
      config.webServiceURL + "/Role/GetBenutzerRolleKostenstelles/" + userId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_COST_CENTRE_FOR_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_COST_CENTRE_FOR_USER_FAILURE,
          });
        }
      },
    );
  }

  deleteCostCenter(costCenterId, plantId) {
    httpRequest(
      config.webServiceURL + "/Kost/DeleteKostenstelle/" + plantId,
      "DELETE",
      JSON.stringify([...costCenterId]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_COST_CENTER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_COST_CENTER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteRoleForUser(userRoleId) {
    httpRequest(
      config.webServiceURL + "/Role/DeleteBenutzerRolle/" + userRoleId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_ROLE_FOR_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_ROLE_FOR_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteCostCentreForUser(userRoleId, costCentreId) {
    httpRequest(
      config.webServiceURL +
        "/Role/DeleteBenutzerRolleKostenstelle/" +
        userRoleId +
        "/" +
        costCentreId,
      "DELETE",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_COST_CENTRE_FOR_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_COST_CENTRE_FOR_USER_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  resetUserPassword(userid) {
    httpRequest(
      config.webServiceURL + "/UserManagement/ResetPassword/" + userid,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.RESET_USER_PASSWORD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.RESET_USER_PASSWORD_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getPlantEquipmentGroupsToAllocate(userId, werkId) {
    httpRequest(
      config.webServiceURL +
        "/Role/GetPlantEquipmentGroupsToAllocate/" +
        userId +
        "/" +
        werkId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE,
            result: res,
          });
        }
      },
    );
  }
  getPlantUser(token, plantId) {
    httpRequest(
      config.webServiceURL +
        "/UserManagement/GetUsers/" +
        token +
        "/" +
        plantId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_PLANT_USER_FAILURE,
            result: res,
          });
        }
      },
    );
  }
  getOrganDomain(orgName, language) {
    httpRequest(
      config.webServiceURL +
        "/Organisation/GetSubDomain/" +
        orgName +
        "/" +
        language,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORG_DOMAN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORG_DOMAN_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getOrganConfig(orgName) {
    httpRequest(
      config.webServiceURL + "/Organisation/GetOrganisation/" + orgName,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORG_CONFIG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORG_CONFIG_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  cloneOrganisation(data) {
    httpRequest(
      config.webServiceURL + "/Organisation/CloneOrganisation",
      "POST",
      JSON.stringify({
        ...data,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.CLONE_ORGANISATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.CLONE_ORGANISATION_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getEquipmentGroupResponsibleUsers(equGrpId) {
    httpRequest(
      config.webServiceURL + "/UserManagement/GetAnlagegruppeUsers/" + equGrpId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getEquipmentGroupUsers(equGrpId) {
    httpRequest(
      config.webServiceURL +
        "/UserManagement/GetEquipmentGroupUsers/" +
        equGrpId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_EQUIP_GRP_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_EQUIP_GRP_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  addResponsibleUserToEqupGroup(data) {
    httpRequest(
      config.webServiceURL + "/UserManagement/AddAnlagegruppeUser",
      "POST",
      JSON.stringify({
        ...data,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteResponsibleUserForEqupGroup(userData) {
    httpRequest(
      config.webServiceURL + "/UserManagement/RemoveAnlagegruppeUser",
      "DELETE",
      JSON.stringify({ ...userData }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_RESPONSIBLE_USER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DELETE_RESPONSIBLE_USER_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getAdminOrPlantAdminPlants() {
    httpRequest(
      config.webServiceURL + "/Werk/GetAdminOrPlantAdminPlants/",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE,
          });
        }
      },
    );
  }

  exportOrganisationData(orgId) {
    httpRequest(
      config.webServiceURL + "/Organisation/ExportOrganizationData/" + orgId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.EXPORT_ORGANISATION_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.EXPORT_ORGANISATION_DATA_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  downloadOrganisationData(orgId) {
    httpRequest(
      config.webServiceURL +
        "/Organisation/DownloadOrganizationExport/" +
        orgId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DOWNLOAD_ORGANISATION_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DOWNLOAD_ORGANISATION_DATA_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getOrganisation(orgId) {
    httpRequest(
      config.webServiceURL + "/Organisation/GetOrganisation/" + orgId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORGANISATION_EXPORT_DETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ORGANISATION_EXPORT_DETAILS_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  // Arbeitsmittel Export - Status abrufen
  getArbeitsmittelExportStatus() {
    httpRequest(
      config.webServiceURL + "/Organisation/GetArbeitsmittelCsvStatus",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  // Arbeitsmittel Export - Export starten (immer async als Background-Job)
  startArbeitsmittelExport() {
    httpRequest(
      config.webServiceURL + "/Organisation/TriggerArbeitsmittelCsvGeneration",
      "POST",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.EXPORT_ARBEITSMITTELGRUPPEN_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  // Arbeitsmittel Export - Fertige Datei herunterladen
  downloadArbeitsmittelExport() {
    httpRequest(
      config.webServiceURL + "/Organisation/DownloadArbeitsmittelExport",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: usermanagementConstant.DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: usermanagementConstant.DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE,
            result: message,
          });
        }
      },
    );
  }
}
export default new UserManagementActions();
